import { render } from "./AvatarConversation.vue?vue&type=template&id=434e94f3&scoped=true&ts=true"
import script from "./AvatarConversation.vue?vue&type=script&lang=ts"
export * from "./AvatarConversation.vue?vue&type=script&lang=ts"

import "./AvatarConversation.vue?vue&type=style&index=0&id=434e94f3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434e94f3"]])

export default __exports__